import { z } from 'zod'

export const createReflectionSchema = z.object({
  segmentId: z.string().min(1, 'Segment is required'),
  type: z.enum(['THEORY', 'CHARACTER', 'THEME']).default('THEORY').optional(),
  title: z.string().max(150, 'Title must be 150 characters or less').optional(),
  reflectionText: z.string().min(1, 'Reflection is required').max(5000, 'Reflection must be 5000 characters or less'),
  tagIds: z.array(z.string()).max(5, 'Maximum 5 tags per reflection').optional(),
  quotedReflectionId: z.string().optional(),
})

export const updateReflectionSchema = z.object({
  type: z.enum(['THEORY', 'CHARACTER', 'THEME']).optional(),
  title: z.string().max(150, 'Title must be 150 characters or less').optional(),
  reflectionText: z.string().min(1, 'Reflection is required').max(5000, 'Reflection must be 5000 characters or less').optional(),
})

export type CreateReflectionInput = z.infer<typeof createReflectionSchema>
export type UpdateReflectionInput = z.infer<typeof updateReflectionSchema>
